import { render, staticRenderFns } from "./TimeLogsReview.vue?vue&type=template&id=2fd3068a&scoped=true"
import script from "./TimeLogsReview.vue?vue&type=script&lang=js"
export * from "./TimeLogsReview.vue?vue&type=script&lang=js"
import style0 from "./TimeLogsReview.vue?vue&type=style&index=0&id=2fd3068a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd3068a",
  null
  
)

export default component.exports